module.exports = __webpack_public_path__ + "static/media/reset.ebf3b7c6.svg";